import apiClient from './apiClient';

const unwrap = async promise => (await promise).data.data;
const service = {
  list: params => unwrap(apiClient.get('/admin/work-allocation', { params })),
  preview: (id, params) => unwrap(apiClient.get(`/admin/work-allocation/${id}/preview`, { params })),
  captureExisting: id => unwrap(apiClient.post(`/admin/work-allocation/from-time-entry/${id}`)),
  accept: (id, body) => unwrap(apiClient.post(`/admin/work-allocation/${id}/accept`, body)),
  employerReviewPreview: (id, params) => unwrap(apiClient.get(`/admin/work-allocation/${id}/employer-review-preview`, { params })),
  reviewEmployer: (id, body) => unwrap(apiClient.post(`/admin/work-allocation/${id}/employer-review`, body)),
};
export default service;
